import React from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { CommonLoader } from "../../../common/CommonLoader";
import { formatAmount } from "../../../../services/utils";

const CotisantStatsChartLine = ({ data, year, frequency, activeTab, selectedMonth, showAccumulateStats, visibleKeys, fetching }) => {

  const getCurrentYearMonth = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Ensure two digits
    return `${year}-${month}`;
  }

  const formatData = () => {
    if (frequency === "MONTHLY") {

      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth() + 1; // 1-based (Jan = 1, Feb = 2, ...)

      let formattedData = [];
      let formattedData2 = [];

      Object.keys(data).forEach(key => {
        formattedData2.push({
          name: key,
          Statutaire: activeTab === 'chiffreAffaire'
            ? ((data[key]["1"] || 0) + (data[key]["2"] || 0) + (data[key]["3"] || 0) + (data[key]["4"] || 0)) / 100
            : data[key]["1"] || 0 + data[key]["2"] || 0 + data[key]["3"] || 0 + data[key]["4"] || 0,
          Fiduciaire: activeTab === 'chiffreAffaire'
            ? (data[key]["5"] || 0) / 100
            : data[key]["5"] || 0,
        });
      });

      for (let i = -3; i < (year.length == 1 && year[0] == currentYear ? currentMonth : 12); i++) {
        const month = (i + 12) % 12 + 1; // Get month (1-12)
        const actualYear = i < 0 ? year[0] - 1 : year[0];
        const monthKey = `${month.toString().padStart(2, "0")}/${actualYear}`;
        const dataKey = `${actualYear}-${month.toString().padStart(2, "0")}`;
        const monthData = data[dataKey] || { "1": 0, "2": 0, "3": 0, "4": 0, "5": 0 };
        formattedData.push({
          name: monthKey, // X-axis label as "MM-YYYY"
          Statutaire: activeTab === 'chiffreAffaire'
            ? ((monthData["1"] || 0) + (monthData["2"] || 0) + (monthData["3"] || 0) + (monthData["4"] || 0)) / 100
            : (monthData["1"] || 0) + (monthData["2"] || 0) + (monthData["3"] || 0) + (monthData["4"] || 0),
          Fiduciaire: activeTab === 'chiffreAffaire'
            ? ((monthData["5"] || 0) + (monthData["ASSOCIATE"] || 0)) / 100
            : (monthData["5"] || 0) + (monthData["ASSOCIATE"] || 0),
          Total: activeTab === 'chiffreAffaire'
            ? (((monthData["1"] || 0) + (monthData["2"] || 0) + (monthData["3"] || 0) + (monthData["4"] || 0)) + ((monthData["5"] || 0) + (monthData["ASSOCIATE"] || 0))) / 100
            : ((monthData["1"] || 0) + (monthData["2"] || 0) + (monthData["3"] || 0) + (monthData["4"] || 0)) + ((monthData["5"] || 0) + (monthData["ASSOCIATE"] || 0))

        });
      }

      return formattedData;
    }

    if (frequency === "YEARLY") {
      let formattedData = [];
      let yearlyData = {};

      Object.entries(data).forEach(([key, value]) => {
        const [year, month] = key.split("-");
        const intYear = parseInt(year, 10);
        const intMonth = parseInt(month, 10);

        // Determine the correct "fiscal year"
        let targetYear = intMonth === 12 ? intYear + 1 : intYear;

        if (!yearlyData[targetYear]) {
          yearlyData[targetYear] = { Statutaire: 0, Fiduciaire: 0 };
        }

        yearlyData[targetYear].Statutaire += activeTab === 'chiffreAffaire' ? ((value["1"] || 0) + (value["2"] || 0) + (value["3"] || 0) + (value["4"] || 0)) / 100 : (value["1"] || 0) + (value["2"] || 0) + (value["3"] || 0) + (value["4"] || 0);
        yearlyData[targetYear].Fiduciaire += activeTab === 'chiffreAffaire' ? ((value["5"] || 0) + (value["ASSOCIATE"] || 0)) / 100 : (value["5"] || 0) + (value["ASSOCIATE"] || 0);
        yearlyData[targetYear].Total += activeTab === 'chiffreAffaire' ? (((value["1"] || 0) + (value["2"] || 0) + (value["3"] || 0) + (value["4"] || 0)) + ((value["5"] || 0) + (value["ASSOCIATE"] || 0))) / 100 : ((value["1"] || 0) + (value["2"] || 0) + (value["3"] || 0) + (value["4"] || 0)) + ((value["5"] || 0) + (value["ASSOCIATE"] || 0));
      });

      formattedData = Object.keys(yearlyData).map(year => ({
        name: year, // X-axis label as "YYYY"
        ...yearlyData[year]
      }));

      return formattedData;
    }

    if (frequency === "DAILY") {
      if (showAccumulateStats == false) {
        let formattedData = [];
        let transformedPrepareData = [];
        const currenDay = new Date().getDate();

        Object.entries(data).forEach(([date, values]) => {
          const keys = date.split('-');
          if (!keys[2]) return;
          formattedData.push({
            name: keys[2] + '/' + keys[1],
            Statutaire: activeTab === 'chiffreAffaire'
              ? ((values["1"] || 0) + (values["2"] || 0) + (values["3"] || 0) + (values["4"] || 0)) / 100
              : (values["1"] || 0) + (values["2"] || 0) + (values["3"] || 0) + (values["4"] || 0),
            Fiduciaire: activeTab === 'chiffreAffaire'
              ? ((values["5"] || 0) + (values["ASSOCIATE"] || 0)) / 100
              : (values["5"] || 0) + (values["ASSOCIATE"] || 0),
            Total: activeTab === 'chiffreAffaire'
              ? (((values["1"] || 0) + (values["2"] || 0) + (values["3"] || 0) + (values["4"] || 0)) + ((values["5"] || 0) + (values["ASSOCIATE"] || 0))) / 100
              : ((values["1"] || 0) + (values["2"] || 0) + (values["3"] || 0) + (values["4"] || 0)) + ((values["5"] || 0) + (values["ASSOCIATE"] || 0))
          });
        });

        if (selectedMonth === getCurrentYearMonth()) {
          for (let index = 0; index < currenDay; index++) {
            transformedPrepareData.push(formattedData[index]);
          }
        } else {
          formattedData.forEach(element => {
            transformedPrepareData.push(element);
          });
        }

        return transformedPrepareData;
      }

      if (showAccumulateStats == true) {
        let formattedData = [];
        let transformedPrepareData = [];
        const currenDay = new Date().getDate();

        Object.entries(data).forEach(([date, values]) => {
          formattedData.push({
            name: date, // Keep "DD/MM" format
            Statutaire: activeTab === 'chiffreAffaire' ? values["statutaire"] / 100 : values["statutaire"],
            Fiduciaire: activeTab === 'chiffreAffaire' ? (values["fiduciaire"]) / 100 : values["fiduciaire"],
            Total: activeTab === 'chiffreAffaire' ? (values["statutaire"] + values["fiduciaire"]) / 100 : values["statutaire"] + values["fiduciaire"],
          });
        });

        // if (selectedMonth === getCurrentYearMonth()) {
        //   for (let index = 0; index < currenDay; index++) {
        //     transformedPrepareData.push(formattedData[index]);
        //   }
        // } else {
        //   formattedData.forEach(element => {
        //     transformedPrepareData.push(element);
        //   });
        // }

        return formattedData;
      }
    }

  };

  const chartData = formatData();


  return (
    <React.Fragment>
      {fetching ? <div style={{ width: '100%' }}><CommonLoader containerHeight={"300px"} iconFontSize={"50px"} iconColor={"#29394D"} /></div> : (
        <ResponsiveContainer width={'100%'} height={300}>
          <LineChart
            data={chartData}
            margin={{
              top: 10,
              right: 30,
            }}
            style={{
              fontSize: '12px',
              fontFamily: 'Roboto',
              fontStyle: 'normal',
              fontWeight: 400
            }}
          >
            <CartesianGrid stroke="#D8DDE2" vertical={false} strokeDasharray="4" />
            <XAxis dataKey="name" tickMargin={10} axisLine={false} tickLine={false} tick={{ fill: '#6D7F92' }} />
            <YAxis tickMargin={10} axisLine={false} tickLine={false} tick={{ fill: '#6D7F92' }} allowDecimals={false} />
            <Tooltip
              contentStyle={{ 'borderRadius': '5px' }}
              itemStyle={{ textTransform: "capitalize" }}
              formatter={activeTab === 'chiffreAffaire' ? (value) => formatAmount(value, false) : (value) => value}
            />
            {
              visibleKeys.includes('Statutaire') &&
              <Line
                dataKey="Statutaire"
                stroke="#007bff"
                activeDot={{ r: 6 }}
                type='linear'
                dot={{ stroke: '#007bff', strokeWidth: 6 }}
                isAnimationActive={true}
                animationDuration={2500}
                animationEasing="ease-out"
              />
            }

            {
              visibleKeys.includes('Fiduciaire') &&
              <Line
                dataKey="Fiduciaire"
                stroke="#ff7300"
                activeDot={{ r: 6 }}
                type='linear'
                dot={{ stroke: '#ff7300', strokeWidth: 6 }}
                isAnimationActive={true}
                animationDuration={2500}
                animationEasing="ease-out"
              />
            }

            <Line
              dataKey="Total"
              stroke="#000"
              activeDot={{ r: 6 }}
              type='linear'
              dot={{ stroke: '#000', strokeWidth: 6 }}
              isAnimationActive={true}
              animationDuration={2500}
              animationEasing="ease-out"
            />

          </LineChart>
        </ResponsiveContainer>
      )}
    </React.Fragment>
  );
};

export default CotisantStatsChartLine;



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/CotisantStatsChartLine.js